import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetActiveSubscriptionsInput } from '../../domain/dtos/get-active-subscriptions-input'
import { Indicator } from '../../domain/enums/indicator'
import { QueryKey } from '../../domain/enums/query-keys'
import { Status } from '../../domain/enums/status'
import { GetActiveSubscriptions } from '../../usecases/get-active-subscriptions'

export const useGetActiveSubscriptions = (input: GetActiveSubscriptionsInput, isLoading: boolean) => {
  const container = useContainer()

  const offerIds = input.offers.filter(({ id }) => id !== 'all').map(({ id }) => id)
  const enabled = !isLoading && offerIds.length > 0
  const initialData = {
    current: 0,
    previous: 0,
    datasets: [],
    percentage: '',
    status: Status.neutral,
    indicator: Indicator.down,
  }

  return useQuery(
    [
      QueryKey.getActiveSubscriptions,
      JSON.stringify({
        period: input.period,
        startDate: input.startDate,
        endDate: input.endDate,
        offerIds: input.offerIds,
      }),
    ],
    ({ signal }) => {
      if (!enabled) {
        return Promise.resolve(initialData)
      }
      return new GetActiveSubscriptions(container.get(HttpClient)).execute(input, signal)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      initialData,
      enabled,
    },
  )
}
